import { Create, CalendarToday, Settings } from "@mui/icons-material"
import VisibilityIcon from '@mui/icons-material/Visibility'
import { useContext, useRef, useState } from "react"
import FigmaTable from "../../FigmaTable/FigmaTable"
import { iconSx } from './SxOrdemServicoTable'
import { statusOrdemServico, tiposOrdemServico } from '../../../Utils/optionsSelects'
import { prioridades } from '../../../Utils/optionsEventos'
import ModalOpcoesOrdemServico from './ModalOpcoesOrdemServico/ModalOpcoesOrdemServico'
import { OrdemServicoContext } from '../../../Providers/OrdemServicoContext/OrdemServicoContext'
import { Tooltip } from '@mui/material'
import { formatDateTime } from '../../../Utils/Utils'

const OrdemServicoTable = ({ dados }) => {
    const { setIdEdit } = useContext(OrdemServicoContext)

    const [modalOpcoesOrdemServico, setModalOpcoesOrdemServico] = useState(false)

    const modalOpcoesOrdemServicoRef = useRef()
    const idOrdemServico = useRef()

    const podeEditarOrdemServico = (status) => {
        return status !== 4 && status !== 3
    }

    const columns = [
        {
            name: 'OS',
            cell: row => row.id
                ? <span title={row.id} >{row.id}</span>
                : "",
            style: {
                width: '1%'
            }
        },
        {
            name: 'Data Abert.',
            cell: row => row.data_cadastro
                ? formatDateTime(row.data_cadastro)
                : "Sem data",
            style: {
                width: '6%'
            }
        },
        {
            name: 'Condomínio / Empresa',
            cell: row => row.condominio
                ? <span title={row.condominio} >{row.id_central}-{row.condominio}</span>
                : "Sem condomínio",
            style: {
                width: '20%'
            }
        },
        {
            name: 'Tipo',
            cell: row => {
                return row.tipo
                    ? <span title={tiposOrdemServico.getOne(row.tipo).descricao}>{tiposOrdemServico.getOne(row.tipo).descricao}</span>
                    : ""
            },
            style: {
                width: '5%'
            }
        },
        {
            name: 'Motivo / Defeito',
            cell: row => row.motivo
                ? <span title={row.motivo} >{row.motivo}</span>
                : "",
            style: {
                width: '10%'
                // textAlign: 'center'
            }
        },
        {
            name: 'Status',
            cell: row => row.status
                ? <span title={statusOrdemServico.getDescricaoStatus(row.status)} >{statusOrdemServico.getDescricaoStatus(row.status)}</span>
                : "",
            style: {
                width: '3%'
                // textAlign: 'center'
            }
        },
        {
            name: 'Prioridade',
            cell: (row) => row.prioridade
                ? <div style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        borderRadius: '50%',
                        width: '10px',
                        height: '10px',
                        backgroundColor: prioridades[row.prioridade - 1].color
                    }} title={prioridades[row.prioridade - 1].nome}></div>
                </div>
                : "",
            style: {
                width: '1%'
            }
        },
        {
            name: 'Ações',
            cell: (row) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'end' }}>
                        {row.agendar && <Tooltip title={formatDateTime(row.data_agendamento)}><CalendarToday sx={{ ...iconSx, cursor: 'default' }}/></Tooltip> }
                        {podeEditarOrdemServico(row.status) ? <Create sx={iconSx} onClick={() => { setIdEdit(row.id) }}/> : <VisibilityIcon sx={iconSx} onClick={() => { setIdEdit(row.id) }}/>}
                        <Settings sx={iconSx} onClick={(e) => handleModalOpcoesOrdemServico(e, row.id)}/>
                    </div>
                )
            },
            button: true,
            center: true,
            style: {
                width: '3%',
                textAlign: 'center'
            }
        }
    ]

    const handleModalOpcoesOrdemServico = async (e, id) => {
        idOrdemServico.current = id
        await setModalOpcoesOrdemServico(!modalOpcoesOrdemServico)
        const modal = modalOpcoesOrdemServicoRef.current
        if (!modal) {
            idOrdemServico.current = null
            return
        }
        let { left, top } = e.target.getBoundingClientRect()
        left -= modal.clientWidth + 5

        if (top + modal.clientHeight + 100 > e.view.screen.availHeight) {
            top -= modal.clientHeight - 10
        } else {
            top += 5
        }

        modal.style.left = `${left}px`
        modal.style.top = `${top}px`
    }

    return (
        <>
            {modalOpcoesOrdemServico && <ModalOpcoesOrdemServico ref={modalOpcoesOrdemServicoRef} setOpen={setModalOpcoesOrdemServico} idOrdemServico={idOrdemServico.current}/>}
            {columns &&
            <FigmaTable data={dados} columns={columns}/>
            }
        </>
    )
}

export default OrdemServicoTable
